import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useTheme } from '../../contexts/ThemeContext';

interface DarkModeToggleProps {
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'inherit';
}

const DarkModeToggle: React.FC<DarkModeToggleProps> = ({ 
  size = 'medium', 
  color = 'inherit' 
}) => {
  const { mode, toggleTheme } = useTheme();

  return (
    <Tooltip title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}>
      <IconButton
        onClick={toggleTheme}
        color={color}
        size={size}
        sx={{
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            transform: 'rotate(180deg)',
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease-in-out',
          }}
        >
          {mode === 'light' ? (
            <Brightness4 
              sx={{ 
                fontSize: size === 'small' ? 20 : size === 'large' ? 28 : 24,
                color: 'inherit'
              }} 
            />
          ) : (
            <Brightness7 
              sx={{ 
                fontSize: size === 'small' ? 20 : size === 'large' ? 28 : 24,
                color: 'inherit'
              }} 
            />
          )}
        </Box>
      </IconButton>
    </Tooltip>
  );
};

export default DarkModeToggle;
